import { Box, Container, LinearProgress, Toolbar } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { Outlet, useMatches, useNavigation } from "react-router-dom";
import Copyright from "./components/Copyright";
import Header from "./components/Header";
import Navigation from "./components/Navigation";
import { TitleContext } from "./hooks/useTitle";

import { last } from "radash";

const drawerWidth = 320;

const defaultBgcolor = (theme) => theme.palette.grey[100];

export const App = () => {
  const navigation = useNavigation();
  const matches = useMatches();
  const [title, setTitle] = useState("");
  const [bgColor, setBgColor] = useState(() => defaultBgcolor);
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    if (title !== "") {
      document.title = `${title} | Player UI`;
    }
  }, [title]);

  useEffect(() => {
    const match = last(
      matches.filter((match) => Boolean(match.handle?.bgcolor))
    );

    setBgColor(() => (match ? match.handle.bgcolor : defaultBgcolor));
  }, [matches]);

  const titleContextValue = useMemo(() => {
    return { title, setTitle };
  }, [title, setTitle]);

  return (
    <TitleContext.Provider value={titleContextValue}>
      <Box sx={{ display: "flex" }}>
        <Header
          drawerWidth={drawerWidth}
          isDrawerOpen={isDrawerOpen}
          title={title}
          toggleDrawer={toggleDrawer}
        />
        <Navigation
          drawerWidth={drawerWidth}
          isDrawerOpen={isDrawerOpen}
          toggleDrawer={toggleDrawer}
        />
        <Box
          component="main"
          sx={{
            backgroundColor: bgColor,
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />
          <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
            <Box sx={{ height: 4 }}>
              {navigation.state === "loading" && (
                <LinearProgress data-testid="loading" />
              )}
            </Box>
            <Outlet />
            <Copyright sx={{ pt: 4 }} />
          </Container>
        </Box>
      </Box>
    </TitleContext.Provider>
  );
};

export default App;
